import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Note } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

type IVideoLesson = {
  id: number;
  message: string;
};

const initialState: IReduxState<any> = {
  data: {} as any,
  isLoading: false,
};

export const AskAIVideoLessonsSlice = createSlice({
  name: "AskAIVideoLessonsSlice",
  initialState,
  reducers: {
    AskAIVideoLesson: (state, _action: PayloadAction<IVideoLesson>) => {
      state.isLoading = true;
    },

    successAskAIVideoLessons: (state, action: PayloadAction<IVideoLesson>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAskAIVideoLessons: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAskAIVideoLessonsResponse: (state) => {
      state.data = {} as IVideoLesson;
    },
  },
});

export const {
  AskAIVideoLesson,
  successAskAIVideoLessons,
  failureAskAIVideoLessons,
  clearAskAIVideoLessonsResponse,
} = AskAIVideoLessonsSlice.actions;

export default AskAIVideoLessonsSlice.reducer;
